import { useEffect } from "react";
import { Product } from "tm-shared/types";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { CatalogKey, catalogStorage } from "@/Services/CatalogStorage";
import { setCatalog, setCatalogLoading } from "@/store/slices/catalog";

const EMPTY_PRODUCTS: Record<string, Product> = {};

export const useCatalog = () => {
    const dispatch = useAppDispatch();
    const products = useAppSelector(
        (s) => s.catalog.data[CatalogKey.Products] ?? EMPTY_PRODUCTS,
    );
    const productsLoading = useAppSelector(
        (s) => s.catalog.loading[CatalogKey.Products],
    );

    useEffect(() => {
        if (products !== EMPTY_PRODUCTS) return;

        const load = async () => {
            dispatch(
                setCatalogLoading({ key: CatalogKey.Products, value: true }),
            );
            const productsMap = await catalogStorage.read(CatalogKey.Products);

            dispatch(
                setCatalog({
                    key: CatalogKey.Products,
                    data: productsMap ?? {},
                }),
            );
            dispatch(
                setCatalogLoading({ key: CatalogKey.Products, value: false }),
            );
        };

        load();
    }, [dispatch, products]);

    return { products, productsLoading };
};
